import NamesExpand from '@Src/_basic/components/NamesExpand';
import { Options } from '@Src/_basic/components/YatungSelect';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  subTitle: Array<string>;
  detectionItem: any;
  detectionIndex: any;
  notificationPriorityOptions: Options[];
  typeAmount: number;
}

export default function DetectionItemCard(props: Props) {
  return (
    <Paper key={props.detectionItem.id} elevation={2} sx={{ padding: '16px 32px', borderRadius: '5px' }}>
      <Stack spacing={3}>
        {props.detectionIndex === 0 && (
          <Grid container spacing={2} direction="row" alignItems="center">
            <Grid item>
              <Typography variant="h2" color="#BB5E00">
                {props.title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="h2" color="#BB5E00">
                <NamesExpand names={props.subTitle} />
              </Typography>
            </Grid>
          </Grid>
        )}
        <Stack direction="row" spacing={1}>
          <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
            {`檢測項目(${props.detectionIndex + 1})：`}
          </Typography>
          <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>{props.detectionItem.name}</Typography>
        </Stack>
        <Stack direction="row" spacing={1}>
          <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>{`回報等級：`}</Typography>
          <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
            {
              props.notificationPriorityOptions.find(
                (option) => option.value === props.detectionItem.notificationPriorityId,
              )?.text
            }
          </Typography>
        </Stack>
        {props.detectionItem.notificationPriorityId2 ? (
          <Stack direction="row" spacing={1}>
            <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>{`Type2回報等級：`}</Typography>
            <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
              {
                props.notificationPriorityOptions.find(
                  (option) => option.value === props.detectionItem.notificationPriorityId2,
                )?.text
              }
            </Typography>
          </Stack>
        ) : (
          ''
        )}

        {props.detectionItem.type2 ? (
          <>
            <Stack direction="row" spacing={1}>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {`檢測(${props.detectionIndex + 1})Type${props.detectionItem.type2}以上>=：`}
              </Typography>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {props.detectionItem.minValue2}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {`檢測(${props.detectionIndex + 1})Type${props.detectionItem.type2}以下<=：`}
              </Typography>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {props.detectionItem.maxValue2}
              </Typography>
            </Stack>
          </>
        ) : (
          ''
        )}
        {props.detectionItem.type ? (
          <>
            <Stack direction="row" spacing={1}>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {`檢測(${props.detectionIndex + 1})Type以上>=：`}
              </Typography>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {props.detectionItem.minValue}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1}>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {`檢測(${props.detectionIndex + 1})Type以下<=：`}
              </Typography>
              <Typography sx={{ minWidth: '60px', fontSize: '18px', flex: 'none' }}>
                {props.detectionItem.maxValue}
              </Typography>
            </Stack>
          </>
        ) : (
          ''
        )}
      </Stack>
    </Paper>
  );
}
